<template>

  <b-sidebar
    id="sidebar-create-monitoring"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ monitoring.id ? $t('Update') : $t('Create') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="monitoringCreate">
          <!-- Uz Name -->
          <b-form-group
            :label="$t('Document name')"
            label-for="name"
          >
            <b-form-input
              id="name"
              v-model="monitoring.name"
              trim
            />
          </b-form-group>

          <!-- En Name -->
          <b-form-group
            :label="$t('Work type')"
            label-for="work_type"
          >
            <v-select
              id="work_type"
              v-model="monitoring.work_type"
              :reduce="(option) => option.id"
              :options="ScientificWorkTypeList"
              :get-option-label="(option) => $langName(option)"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Reporting period')"
            label-for="work_type"
          >
            <v-select
              id="work_type"
              v-model="monitoring.period"
              :reduce="(option) => option.id"
              :options="periods"
              label="admission_year"
              @input="selectedPeriod"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Quarter')"
            label-for="quarter"
          >
            <v-select
              id="quarter"
              v-model="monitoring.quarter"
              :reduce="(option) => option.id"
              :options="quarters"
              label="quarter"
            />
          </b-form-group>

          <b-form-group
            :label="$t('File')"
            label-for="file"
          >
            <div
              v-if="monitoring.file"
              class="input-group"
            >
              <div class="input-group-prepend">
                <span class="input-group-text border-success">
                  <b-link
                    :href="monitoring.file"
                    download="file"
                    target="_blank"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      class="cursor-pointer"
                      size="16"
                    />
                  </b-link>

                </span>
              </div>
              <div
                class="form-control border-success"
              >
                {{ $t('File') }}
              </div>
              <div
                class="input-group-append"
              >
                <span class="input-group-text">
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer danger"
                    size="16"
                    @click="cancel"
                  />
                </span>
              </div>
            </div>
            <validation-provider
              v-else
              #default="{ errors }"
              :name="$t('File')"
              rules="file-size:10"
            >
              <b-form-file
                v-model="monitoring.file_upload"
                :placeholder="$t('Choose a file or drop it here...')"
                accept="application/pdf"
                :drop-placeholder="$t('Drop file here...')"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        <!-- Form Actions -->
        </validation-observer>
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ monitoring.id ? $t('Update') : $t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>
<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton, BFormFile, BLink,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import { onUnmounted } from '@vue/composition-api/dist/vue-composition-api.js'
import vSelect from 'vue-select'
import periodModule from '@/store/period/index'
import store from '@/store'
import { required, fileSize } from '@/libs/validations/validations'
import { ScientificWorkTypeList } from '@/classes/ScientificWorkTypes'

export default {
  name: 'Create',
  directives: {
    Ripple,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BFormFile,
    BFormInput,
    BButton,
    vSelect,
    BLink,
  },
  data() {
    return {
      quarters: [],
      required,
      fileSize,
    }
  },
  computed: {
    periods() {
      return this.$store.state.period.periods
    },
    monitoring: {
      get() {
        return this.$store.state.monitoring.monitoring
      },
      set(data) {
        this.$store.commit('monitoring/UPDATE', data)
      },
    },
  },
  mounted() {
    this.loadData()
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    selectedPeriod(id) {
      const data = this.$store.getters['period/getPeriod'](id)
      this.quarters = data.quarters
    },
    loadData() {
      this.$store.dispatch('period/list', { limit: 9999, ordering: '-admission_year', monitoring: true })
    },
    clear(hide) {
      this.$store.commit('monitoring/FRESH')
      this.$refs.monitoringCreate.reset()
      hide()
    },
    cancel() {
      this.monitoring.file = null
      this.monitoring.file_upload = null
    },
    submit(hide) {
      this.$refs.monitoringCreate.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.monitoring, `monitoring/${this.monitoring.id ? 'createOrPatch' : 'createOrPatch'}`, () => {
            this.$emit('refetchData')
            this.$store.commit('monitoring/FRESH')
          })
          hide()
        }
      })
    },
  },
  setup() {
    const MODULE_PERIOD = 'period'
    if (!store.hasModule(MODULE_PERIOD)) store.registerModule(MODULE_PERIOD, periodModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_PERIOD)) store.unregisterModule(MODULE_PERIOD)
    })
    return {
      MODULE_PERIOD,
      ScientificWorkTypeList,
    }
  },
}
</script>

  <style scoped />
